import { IConfigurationWorkOrder } from '@phrospr/lib-models';

// Single gate for "does this planning item type get work-order actions":
// work orders on, type in the allow-list (empty allow-list = all types) and
// not in the disabled list.
export function workOrderEnabledForPlanningType(
    workOrders: Partial<IConfigurationWorkOrder> | undefined,
    planningItemType: string,
): boolean {
    if (!workOrders?.enabled) return false;
    const enabledTypes = workOrders.enabledPlanningTypes ?? [];
    if (enabledTypes.length > 0 && !enabledTypes.includes(planningItemType)) return false;
    return !(workOrders.disabledPlanningTypes ?? []).includes(planningItemType);
}
